// How a failed token renewal is handled.
// - definitive: Keycloak refused the refresh token (or there is none), so the session is over;
// - transient: network error, timeout, 5xx or any other OAuth error; keep the workspace
//   mounted and retry with backoff until renewal succeeds or a definitive error arrives.
export const DEFINITIVE_RENEWAL_ERROR_CODES = Object.freeze(['invalid_grant', 'login_required', 'invalid_token', 'unauthorized_client']);
export const RENEWAL_RETRY_BASE_MS = 5000;
export const RENEWAL_RETRY_MAX_MS = 30000;

// oidc-client-ts raises OAuth token-endpoint errors as `ErrorResponse` with the `error` code.
export function isDefinitiveRenewalError(error) {
  return !!error && error.name === 'ErrorResponse' && DEFINITIVE_RENEWAL_ERROR_CODES.includes(error.error);
}

export function classifyRenewalFailure(error, { renewable = true } = {}) {
  return !renewable || isDefinitiveRenewalError(error) ? 'definitive' : 'transient';
}

// 5 s, 10 s, 20 s, then 30 s for every later attempt.
export function renewalRetryDelayMs(attempt) {
  const step = Math.max(0, Math.floor(Number(attempt) || 0));
  return Math.min(RENEWAL_RETRY_BASE_MS * 2 ** Math.min(step, 10), RENEWAL_RETRY_MAX_MS);
}
